import React from "react";
import LottieAnimation from "../Lottie/LottieAnimation";
import lotti from "../Animation/51083-website-interface.json";
import Typography from "@material-ui/core/Typography";

function WorkingWithUs() {
  //   React.useEffect(() => {
  //     document.title = "Privacy Policy";
  //   }, []);

  return (
    <div
      style={{
        fontFamily: '"Helvetica Neue" ,Helvetica, Arial, "sans-serif"',
        padding: "2em",
      }}
    >
      <LottieAnimation lotti={lotti} width={200} height={200} />
      <Typography>ما هو شاور؟</Typography>
      <Typography>
        شاور للاستشارت القانونية تطبيق يقدم خدمة الوساطة بين المستشار وطالب
        الخدمة
      </Typography>
      <Typography>لماذا شاور؟</Typography>
      <Typography>- دفع فوري وربح سريع.</Typography>
      <Typography>- قدم استشاراتك وين ما كنت.</Typography>
      <Typography>- رتب وقتك وابد معنا.</Typography>
      <Typography>لكل مستشار أو محامي سجل معنا اليوم من خلال الرابط</Typography>
      <a href="https://forms.gle/frydC3QWXfZQd6XP8">رابط التسجيل</a>
    </div>
  );
}

export default WorkingWithUs;
